<template>
  <Skeleton title avatar :row="3" :loading="skeletonLoading" />
  <div class="dashboard-wrap">
    <img
      class="dashboard-top-bg"
      src="../../assets/images/dashboard-top-bg.jpg"
    />
    <div class="dashboard-header">
      <div class="dashboard-header-head">
        <img :src="userInfo.headimgurl" />
        <div class="dashboard-header-head-desc">
          <Tag v-if="!userInfo.role" plain type="danger">普通用户</Tag>
          <Tag plain type="success" v-if="userInfo.role && userInfo.role == 'cheng'"
            >承租户</Tag
          >
          <Tag plain type="primary" v-if="userInfo.role && userInfo.role == 'zhuan'"
            >转租户</Tag
          >
          <Tag plain type="warning" v-if="userInfo.role && userInfo.role == 'hezu'"
            >合租户</Tag
          >
          <Tag plain type="danger" v-if="userInfo.role && userInfo.role == 'da'"
            >打工人</Tag
          >
        </div>
      </div>

      <div class="dashboard-header-body">
        <div class="dashboard-header-name">
          <span>{{ userInfo.realName || userInfo.nickname }}</span>
          <span
            class="dashboard-header-edit"
            @click="changePage('UpdateUser')"
          ></span>
        </div>
        <div class="dashboard-header-role">
          <span v-if="!userInfo.role">暂无铺面</span>
          <span v-if="userInfo.role && userInfo.stallNo"
            >铺面编号：{{ userInfo.stallNo }}</span
          >
        </div>
      </div>
    </div>
    <!-- 未申请为企业 -->
    <div
      class="dashboard-banner"
      @click="changePage('map')"
      v-if="!userInfo.role "
    ></div>
    <div
      class="dashboard-banner-two"
      @click="changePage('applyjoin')"
      v-if="!userInfo.role && userInfo.repairWorker != '1' && userInfo.repairManager != '1' && userInfo.propMarketManager != '1'"
    ></div>
    <div
      class="dashboard-banner-three"
      @click="changePage('repairOrFeedback')"
      v-if="userInfo.repairWorker == '1' ||  userInfo.repairManager == '1'"
    ></div>

    <div
      class="dashboard-banner-four"
      @click="changePage('propertyInspection')"
      v-if="!userInfo.role && userInfo.propMarketManager == '1' "
    ></div>

    <!-- 已入驻为企业用户 -->
    <template v-if="userInfo.role && userInfo.repairWorker != '1' && userInfo.repairManager != '1' ">
      <!-- 水电费合并模块 -->
      <div class="dashboard-wallet-merged">
        <!-- 电费行 -->
        <div class="dashboard-wallet-row">
          <div class="dashboard-wallet-left">
            <div class="dashboard-wallet-left-header">
              <div class="dashboard-wallet-left-header-des">电费余额(元)</div>
              <img
                class="dashboard-wallet-left-header-msg"
                src="../../assets/images/icon-qa.png"
                alt=""
              />
            </div>
            <div class="dashboard-wallet-left-money">
              {{ userInfo.stallElectricityBalance||0 }}
            </div>
          </div>
          <div class="dashboard-wallet-left">
            <div class="dashboard-wallet-left-header">
              <div class="dashboard-wallet-left-header-elec">可用度数(度)</div>
            </div>
            <div class="dashboard-wallet-left-elec"> {{ userInfo.stallElectricityRemain||0 }}</div>
          </div>
          <div class="dashboard-wallet-right" @click="handleRechargeElectricty" >
            <span>充电费</span>
          </div>
        </div>
        
        <!-- 分隔线 -->
        <div class="dashboard-wallet-divider">
          <div class="divider-line"></div>
          <div class="divider-text">水电费</div>
          <div class="divider-line"></div>
        </div>
        
        <!-- 水费行 -->
        <div class="dashboard-wallet-row">
          <div class="dashboard-wallet-left">
            <div class="dashboard-wallet-left-header">
              <div class="dashboard-wallet-left-header-des">水费余额(元)</div>
              <img
                class="dashboard-wallet-left-header-msg"
                src="../../assets/images/icon-qa.png"
                alt=""
              />
            </div>
            <div class="dashboard-wallet-left-money">
              {{ userInfo.stallWaterBalance||0 }}
            </div>
          </div>
          <div class="dashboard-wallet-left">
            <div class="dashboard-wallet-left-header">
              <div class="dashboard-wallet-left-header-elec">可用吨数(吨)</div>
            </div>
            <div class="dashboard-wallet-left-elec"> {{ userInfo.stallWaterRemain||0 }}</div>
          </div>
          <div class="dashboard-wallet-right water-recharge-btn" @click="handleRechargeWater" >
            <span>充水费</span>
          </div>
        </div>
      </div>
      <div class="dashboard-wallet-other" @click="handleChangeCurrentShop">
        <div class="dashboard-wallet-other-img">          
          <img :src="exchange" style="height: 23px" />
        </div>
        <div class="dashboard-wallet-other-name">{{ userInfo.shopName }}</div>
        <div class="dashboard-wallet-other-role"> {{userInfo.shopStatus == 'cheng'?'承租':userInfo.shopStatus == 'hezu'?'合租': userInfo.shopStatus == 'zhuan'?'转租':'-' }}</div>
      </div>
      <div class="dashboard-content">
        <div class="dashboard-content-header">
          <div class="dashboard-content-title">
            工作台
          </div>
          <div class="dashboard-marquee" v-if="unpaidBillCnt > 0" @click="changePage('unpaidBill')">
            <span class="dashboard-marquee-text">您有 <span class="dashboard-marquee-num">{{ unpaidBillCnt }}</span> 条待支付账单，点击支付。</span>
          </div>
        </div>
        <div class="dashboard-list">
          <div
            class="dashboard-list-item"
            v-for="(item, index) in entryList"
            :key="index"
            @click="item.click"
          >
            <Badge :content="item.title === '待支付' && unpaidBillCnt > 0 ? unpaidBillCnt : ''" :show-zero="false">
              <img class="dashboard-list-item-img" :src="item.icon" />
            </Badge>
            <div class="dashboard-list-item-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
  <Dialog v-model:show="showInviteVisible" title="邀请确认" cancel-button-text='关闭' show-cancel-button  @closed="handleShutDownInvite" @confirm="handleConfirmInvite">
    您受邀成为店铺《{{inviteDetail?.shopName}}》的{{inviteDetail?.inviteType == 'zhuan'?'转租户': inviteDetail?.inviteType  == 'hezu'?'合租户' :'员工'}}，有效期至{{moment(inviteDetail?.expireTime).format('YYYY-MM-DD HH:mm:ss') }}，请确认。
    <Loading type="spinner" v-if="inviteLoading" class="app-loading" color="#1989fa" />
  </Dialog>
  <Dialog 
    v-model:show="showChangeShopVisible" 
    title="切换店铺" 
    show-cancel-button    
    cancelButtonText="关闭"    
    confirmButtonText="切换"
    :before-close="handleSubmitChangeShop"
    
    >
    <RadioGroup v-model="changeTargetShop">
      <CellGroup inset>
        <Cell :title="shopItem.shopName" clickable  v-for="shopItem in loginUserShopList">
          <template #right-icon>
            <Radio :name="shopItem.id" />
          </template>
        </Cell>       
      </CellGroup>
    </RadioGroup>
  </Dialog>
  
</template>

<script setup>
import { useStore } from "vuex";
import { ref, computed, onMounted,reactive,toRefs} from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { Skeleton, Tag,Dialog,Loading,RadioGroup,CellGroup,Cell,Radio,Badge } from "vant";
import moment from 'moment'
import shopIcon from "@/assets/images/shop-icon.png";
import personIcon from "@/assets/images/person-icon.png";
import nextIcon from "@/assets/images/next-icon.png";
import notifyIcon from "@/assets/images/notify-icon.png";
import rentIcon from "@/assets/images/rent-icon.png";
import noticeIcon from "@/assets/images/notice.png";
import wyf from "@/assets/images/wyf.png";
import bxIcon from "@/assets/images/bx.png";
import yfIcon from "@/assets/images/yf.png";
import unpaidBill from "@/assets/images/unpaidBill.png";
import canteenIcon from "@/assets/images/pay-order.png";

import vip from "@/assets/images/vip.png";
import yj from "@/assets/images/yj.png";
import settlein from "@/assets/images/settlein.png";
import payOrder from "@/assets/images/pay-order.png";
import exchange from "@/assets/images/exchange.png";

import { numberFormat } from "@/service/util";
import { applySettleInValid,getInviteDetail,inviteStaff ,getLoginUserShops,changeLoginUserCurrentShop,getUnpaidBillUnpaidCnt} from "@/service/api";
import { showToast, showConfirmDialog,showFailToast } from "vant";

const route = useRoute();
const store = useStore();

const userInfo = computed(() => store.state.userInfo);

const skeletonLoading = computed(() => !store.getters.hasLogin);

const formatPersonalMoney = computed(() =>
  numberFormat(userInfo.personalMoney)
);

const entryList = ref([ 
  {
    icon: shopIcon,
    title: "我的商铺",
    click: () => {
      changePage("applyModify");
    },
  },
  {
    icon: personIcon,
    title: "人员管理",
    click: () => {
      console.log("人员管理");
      router.push("/contacts");
    },
  },
  {
    icon: nextIcon,
    title: "租金",
    click: () => {
      router.push("/rent/" + userInfo.value.shopId);
    },
  },
  // {
  //   icon: yj,
  //   title: "押金",
  //   click: () => {
  //     router.push("/deposit/" + userInfo.value.shopId);
  //   },
  // },
  {
    icon: unpaidBill,
    title: "待支付",
    click: () => {
      changePage("unpaidBill");
    },
  },
  {
    icon: canteenIcon,
    title: "食堂",
    click: () => {
      router.push("/canteen");
    },
  },
  {
    icon: wyf,
    title: "物业费",
    click: () => {
      router.push("/property/" + userInfo.value.shopId);
    },
  },
  {
    icon: payOrder,
    title: "支付账单",
    click: () => {
      router.push("/bill/" + userInfo.value.shopId);
    },
  }, 
  {
    icon: noticeIcon,
    title: "通知",
    click: () => {
      router.push("notice");
    },
  },
  {
    icon: settlein,
    title: "入驻",
    click: () => {
      changePage("applyjoin");
    },
  },  
  {
    icon: rentIcon,
    title: "招商一张图",
    click: () => {
      router.push("map");
    },
  },
  {
    icon: bxIcon,
    title: "报修",
    click: () => {
      changePage("repairOrFeedback");
    },
  },
  {
    icon: yfIcon,
    title: "验房",
    click: () => {
      changePage("propertyInspection");
    },
  },
  // {
  //   icon: unpaidBill,
  //   title: "待支付",
  //   click: () => {
  //     changePage("unpaidBill");
  //   },
  // } 
]);

const unpaidBillCnt = ref(0);

const state = reactive({
  inviteLoading:false,
  showInviteVisible:false,
  loginUserShopList:[],
  showChangeShopVisible:false,
  changeTargetShop:userInfo.shopId,
  inviteDetail:null
});

const { inviteLoading,showInviteVisible,loginUserShopList,showChangeShopVisible,changeTargetShop,inviteDetail } = toRefs(state);

const handleShutDownInvite = () => {

};

const handleConfirmInvite = () => {
  if(inviteDetail.value.inviteType == 'da'){
    inviteStaff({inviteId:inviteDetail.value.id}).then((res)=>{
      location.reload()
    }).catch((e=>{
      showFailToast(e)
    }))
  }
  if(inviteDetail.value.inviteType == 'hezu' || inviteDetail.value.inviteType =='zhuan'){
    applySettleInValid()
      .then(() => {
        router.push({path:'/applyjoin', query: {inviteId:inviteDetail.value.id}})
      })
      .catch((err) => {
        showToast(err);
      })
  }  
};

const changePage = (url) => {
  if (url == "applyjoin") {
    //校验申请
    applySettleInValid()
      .then(() => {
        router.push(url);
      })
      .catch((err) => {
        showToast(err);
      })
      .finally(() => {});
  } else if (url == "applyModify") {
    //校验申请
    router.push(url + "/" + userInfo.value.shopId);
  } else if (url.includes("repairOrFeedback")) {
    if(userInfo.value.repairManager == '1' || userInfo.value.repairWorker == '1'){ 
      router.push("repair-feedback");
    }else{
      router.push("repair");
    }
  } else {
    router.push(url);
  }
};


const handleRechargeElectricty = () => {
  // if(tmpForbidStallNo.includes(userInfo.value.stallNo)){
  //   showToast('由于桐乡市南区皮毛市场开发有限公司拖欠软件服务费，现部分功能暂停使用！')
  // }else{
  //   router.push("recharge/" + userInfo.value.shopId);
  // }
  router.push("recharge/" + userInfo.value.shopId);
};

const handleRechargeWater = () => {
  // 水费充值功能，可以复用电费充值的路由或创建新的水费充值页面
  router.push("water-recharge/" + userInfo.value.shopId);
};

const handleChangeCurrentShop = () => {
  getLoginUserShops()
      .then((res) => {
        loginUserShopList.value = res
        showChangeShopVisible.value = true
      })
      .catch((err) => {
        showToast(err);
      })  
};

const handleSubmitChangeShop = (action) => {
  if(action == 'confirm'){
    if(!changeTargetShop.value){
      showToast('请选择切换店铺！')
      return false
    }
    changeLoginUserCurrentShop({shopId:changeTargetShop.value})
      .then((res) => {
        window.location.reload();     
      })
      .catch((err) => {
        showToast(err);
        return false
      })     
  }
  if(action == 'cancel'){
    showChangeShopVisible.value = false
  }  
};

onMounted(() => {
  if(route.query.inviceCode){
    getInviteDetail({inviteId:route.query.inviceCode}).then((res)=>{
      if(res && res.isValid == '1'){
        showInviteVisible.value = true;
        inviteDetail.value = res
      }
    }).catch(e=>{
      showToast(e)
    })
  }
  if (route.query.redirect === 'applyjoin') {
    changePage('applyjoin');
  }
  // 查询待支付账单数量
  if (userInfo.value?.shopId) {
    getUnpaidBillUnpaidCnt({ shopId: userInfo.value.shopId }).then((res) => {
      unpaidBillCnt.value = res || 0;
    }).catch(() => {});
  }
})
</script>

<style lang="scss" scoped>
.dashboard-wrap {
  width: 100%;
  height: 100%;
  background: #fffcf4;
  position: relative;
  box-sizing: border-box;
  padding: 30px 16px;
  position: relative;
  height: 100%;
}

.dashboard-top-bg {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.dashboard-header {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  padding: 0 30px 0 16px;

  &-head {
    width: 65px;
    height: 65px;
    margin-right: 10px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
      display: block;
    }

    &-desc {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      text-align: center;
    }
  }

  &-body {
    position: relative;
    flex: 1;
  }

  &-name {
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    line-height: 25px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-edit {
    height: 29px;
    width: 29px;
    background-image: url("~@/assets/images/personal-edit.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-left: 6px;
  }

  &-role {
    margin-top: 6px;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    max-width: 155px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.dashboard-wallet {
  position: relative;
  margin-top: 30px;
  width: 100%;
  height: 93px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 30px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

  &-left {
    &-money {
      font-size: 16px;
      font-family: "TiHeiM";
      color: #fe6e19;
    }

    &-elec {
      font-size: 16px;
      font-family: "TiHeiM";
      color: #ffd13d;
    }

    &-header {
      display: flex;
      align-items: center;
      margin-bottom: 5px;

      &-des {
        font-size: 14px;
        color: #363636;
        line-height: 17px;
        margin-right: 3px;
      }

      &-elec {
        font-size: 13px;
        color: #a5a5a5;
        line-height: 16px;
        margin-right: 3px;
      }
      &-msg {
        width: 16px;
        height: 16px;
      }
    }
  }

  &-right {
    width: 40px;
    height: 28px;
    background: #ffd13d;
    border-radius: 14px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ffffff;
  }
}

// 水电费合并模块样式
.dashboard-wallet-merged {
  position: relative;
  margin-top: 30px;
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  overflow: hidden;

  .dashboard-wallet-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 22px 30px;
    height: 93px;
    box-sizing: border-box;
  }

  .dashboard-wallet-divider {
    display: flex;
    align-items: center;
    padding: 0 30px;
    height: 40px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    position: relative;

    .divider-line {
      flex: 1;
      height: 1px;
      background: linear-gradient(90deg, transparent 0%, #d1d5db 50%, transparent 100%);
    }

    .divider-text {
      margin: 0 15px;
      font-size: 12px;
      color: #6b7280;
      font-weight: 500;
      background: #ffffff;
      padding: 4px 12px;
      border-radius: 12px;
      border: 1px solid #e5e7eb;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
  }

  .dashboard-wallet-left {
    &-money {
      font-size: 16px;
      font-family: "TiHeiM";
      color: #fe6e19;
    }

    &-elec {
      font-size: 16px;
      font-family: "TiHeiM";
      color: #ffd13d;
    }

    &-header {
      display: flex;
      align-items: center;
      margin-bottom: 5px;

      &-des {
        font-size: 14px;
        color: #363636;
        line-height: 17px;
        margin-right: 3px;
      }

      &-elec {
        font-size: 13px;
        color: #a5a5a5;
        line-height: 16px;
        margin-right: 3px;
      }
      &-msg {
        width: 16px;
        height: 16px;
      }
    }
  }

  .dashboard-wallet-right {
    width: 50px;
    height: 28px;
    background: #ffd13d;
    border-radius: 14px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ffffff;
  }

  .water-recharge-btn {
    background: #1989fa !important;
  }
}

.dashboard-wallet-other {
  margin-top: -20px;
  width: 100%;
  height: 56px;
  background: #f2c89694;
  border-radius: 12px;
  box-shadow: rgba(128, 128, 128, 0.3) 0px 2px 8px 0px;
  box-sizing: border-box;
  padding: 20px 14px 0;
  display: flex;
  align-items: center;
  
  &-img {
    font-size: 14px;
    color: #6b6b6b;
  }
  &-name {
    margin-left: 5px;
    font-size: 14px;
    font-weight: 550;
    color: #a06d3d;
  }

  &-role {
    float: right;
    font-size: 12px;
    color: #a06d3d;
    margin-left: auto;
    border: 1px solid #a06d3d;
    border-radius: 5px;
    padding: 3px;
  }
}

.dashboard-banner {
  position: relative;
  margin-top: 60px;
  width: 100%;
  height: 103px;
  background-image: url("~@/assets/images/banner-map.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 12px;
  &-two {
    position: relative;
    margin-top: 15px;
    width: 100%;
    height: 103px;
    background-image: url("~@/assets/images/banner-join.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 12px;
  }
  &-three {
    position: relative;
    margin-top: 25px;
    width: 100%;
    height: 150px;
    background-image: url("~@/assets/images/banner-repair.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 12px;
  }
  &-four {
    position: relative;
    margin-top: 25px;
    width: 100%;
    height: 150px;
    background-image: url("~@/assets/images/banner-property.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 12px;
  }
}

.dashboard-content {
  position: relative;
  margin-top: 14px;
  width: 320px;
  background: #ffffff;
  border-radius: 12px;
  padding: 5px 12px;
}

.dashboard-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  &-item {
    padding: 20px 0;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &-img {
      width: 40px;
      height: 40px;
      margin-bottom: 3px;
    }

    &-title {
      width: 80px;
      font-size: 14px;
      text-align: center;
      color: #666666;
      line-height: 17px;
    }

    &-tip {
      position: absolute;
      right: 17px;
      top: 15px;
      width: 8px;
      height: 8px;
      background: #ffd13d;
      border-radius: 50%;
    }
  }
}

.dashboard-content-header {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.dashboard-content-title {
  color: #363636;
  font-weight: bold;
  margin: 5px 0 0 5px;
  font-size: small;
  border-left: 5px solid #ffd13d;
  padding-left: 5px;
  white-space: nowrap;
  flex-shrink: 0;
}

.dashboard-marquee {
  flex: 1;
  overflow: hidden;
  margin-left: 10px;
  margin-top: 5px;
  cursor: pointer;
}

.dashboard-marquee-text {
  display: inline-block;
  white-space: nowrap;
  font-size: 14px;
  color: #666;
  animation: marquee 8s linear infinite;
}

.dashboard-marquee-num {
  color: #ee0a24;
  font-weight: bold;
  font-size: 16px;
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
